export default __webpack_public_path__ + "static/media/money-transfer.57184776.png";